import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, money } from "../../lib/api";
import { CheckCircle2 } from "lucide-react";
import EnableNotificationsPrompt from "../../components/common/EnableNotificationsPrompt";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${id}`).then(({ data }) => setOrder(data));
  }, [id]);

  if (!order) return <div className="px-6 py-24 text-center">Loading…</div>;

  return (
    <div className="px-6 md:px-12 lg:px-24 py-20 max-w-2xl mx-auto text-center" data-testid="order-success-page">
      <CheckCircle2 size={56} className="mx-auto text-[hsl(var(--kb-primary))] mb-6" />
      <div className="overline mb-2">Order Confirmed</div>
      <h1 className="font-display text-4xl lg:text-5xl mb-4">Thank you for your order.</h1>
      <p className="text-[hsl(var(--kb-muted))] mb-8">Order <span className="font-mono" data-testid="order-id">#{order.id.slice(0, 8)}</span> · {money(order.total)}</p>
      <div className="text-left mb-6">
        <EnableNotificationsPrompt
          storageKey="customer_order_status"
          title="Get live order updates"
          message="We'll ping you when your order ships, is out for delivery, and arrives — no need to keep refreshing."
          ctaLabel="Enable alerts"
          testIdPrefix="customer-order-push"
        />
      </div>
      <div className="bg-[hsl(var(--kb-surface-alt))] p-6 text-left mb-8">
        <div className="overline mb-3">Delivery to</div>
        <p className="text-sm">
          <b>{order.address?.name}</b><br />
          {order.address?.line1}, {order.address?.line2}<br />
          {order.address?.city}, {order.address?.state} {order.address?.pincode}
        </p>
      </div>
      <Link to="/account" className="kb-btn-primary inline-block">View my orders</Link>
    </div>
  );
}
